import { KlydoPreview as KlydoPreviewType } from '../../../api/public';
import { DSCardContent } from '../../../design-system/Card';
import DSBox from '../../../design-system/DSBox';
import DSKlydoCard from '../../../design-system/Klydo/DSKlydoCard';
import { useTheme } from '@mui/material';
import { DSTitleTypography } from '../../../design-system/Typography';
import DSDivider from '../../../design-system/DSDivider';
import KlydoPreview from '../../../components/KlydoPlayer/Wrappers/KlydoPreview';

export type PublicKlydoCardViewProps = {
  klydo: KlydoPreviewType;
  onSelect?: (klydo: KlydoPreviewType) => void;
  pendulumLogo?: string;
};

const PublicKlydoCardView = ({
  klydo,
  onSelect,
  pendulumLogo,
}: PublicKlydoCardViewProps) => {
  const { spacing } = useTheme();

  const handleCardClick = () => {
    if (onSelect) {
      onSelect(klydo);
    }
  };

  return (
    <DSKlydoCard onClick={handleCardClick}>
      <KlydoPreview
        klydo={klydo}
        isPaused={true}
        backgroundHidden
        dialsHidden
        scale={0.2}
        pendulumLogo={pendulumLogo}
        // This card only ever renders klydos from a public (approved)
        // collection - logoUrl already arrives pre-sized, so no client-side
        // scaling should run on it.
        isApprovedCollection
      />

      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DSCardContent
          sx={{
            textAlign: 'left',
            paddingBottom: 0,
          }}
        >
          <DSBox sx={{ minHeight: spacing(14), width: spacing(19) }}>
            <DSTitleTypography
              sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordWrap: 'break-word',
                width: '100%',
                whiteSpace: 'normal',
              }}
            >
              {klydo.name}
            </DSTitleTypography>
          </DSBox>
        </DSCardContent>
        <DSDivider
          flexItem
          sx={{
            alignSelf: 'flex-start',
            width: '90%',
          }}
        />
      </DSBox>
    </DSKlydoCard>
  );
};

export default PublicKlydoCardView;
